<!-- Dropdown.vue -->
<template>
  <div class="dropdown" :ref="(el) => dropdownRef = el">
    <div class="dropdown__trigger" @click="toggle">
      <slot name="trigger" :toggle="toggle"></slot>
    </div>

    <Transition name="fade">
      <div v-if="isOpen" class="dropdown__menu" :class="placement">
        <slot name="menu" :close="close" />
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const emits = defineEmits(['isOpen'])

const props = defineProps({
  placement: { type: String, default: 'bottom-left' }, // bottom-left | bottom-right
})

const isOpen = ref(false)
const dropdownRef = ref(null)

const toggle = () => {
  isOpen.value = !isOpen.value;
  emits('isOpen', isOpen.value);
}
const close = () => {
  isOpen.value = false;
  emits('isOpen', isOpen.value);
}

function onClickOutside(e) {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target)) close();
}

onMounted(() => document.addEventListener('click', onClickOutside));
onUnmounted(() => document.removeEventListener('click', onClickOutside));

defineExpose({ close, toggle });
</script>

<style scoped>
.dropdown { position: relative; display: inline-block; }

.dropdown__menu {
  position: absolute;
  top: 100%;
  margin-top: 6px;
  background: #fff;
  background-color: var(--white-color);
  border: 1px solid var(--light-grey-color);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 8px;
  z-index: 50;
}
.dropdown__menu.bottom-right { right: 0; }
.dropdown__menu.bottom-left { left: 0; }
.dropdown__menu.top-left { top: unset; bottom: 100%; left: 0; margin-bottom: 6px; margin-top: 0;}
.dropdown__menu.top-right { top: unset ; bottom: 100%; right: 0; margin-bottom: 6px; margin-top: 0;}

.fade-enter-active, .fade-leave-active {
  transition: opacity .15s ease, transform .15s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>